var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdminPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2818 28.56C22.1685 28.56 28.5618 22.1666 28.5618 14.28C28.5618 6.39337 22.1685 0 14.2818 0C6.3952 0 0.00183105 6.39337 0.00183105 14.28C0.00183105 22.1666 6.3952 28.56 14.2818 28.56Z",
    fill: "#E7266C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1654 26.6841C23.012 26.6841 28.5622 21.1339 28.5622 14.2874C28.5622 7.44084 23.012 1.89062 16.1654 1.89062C9.31889 1.89062 3.76868 7.44084 3.76868 14.2874C3.76868 21.1339 9.31889 26.6841 16.1654 26.6841Z",
    fill: "#CC195B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2741 24.3712C23.8435 24.3712 28.3584 19.8563 28.3584 14.2869C28.3584 8.71752 23.8435 4.20264 18.2741 4.20264C12.7047 4.20264 8.18982 8.71752 8.18982 14.2869C8.18982 19.8563 12.7047 24.3712 18.2741 24.3712Z",
    fill: "#A9154C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.4666 22.2205C18.8484 22.2205 22.4006 18.6684 22.4006 14.2865C22.4006 9.90471 18.8484 6.35254 14.4666 6.35254C10.0848 6.35254 6.53259 9.90471 6.53259 14.2865C6.53259 18.6684 10.0848 22.2205 14.4666 22.2205Z",
    fill: "#660F2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4924 20.6178C17.9889 20.6178 20.8233 17.7834 20.8233 14.2869C20.8233 10.7905 17.9889 7.95605 14.4924 7.95605C10.996 7.95605 8.16156 10.7905 8.16156 14.2869C8.16156 17.7834 10.996 20.6178 14.4924 20.6178Z",
    fill: "#88123D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.4662 21.4691C18.4329 21.4691 21.6485 18.2535 21.6485 14.2868C21.6485 10.3201 18.4329 7.10449 14.4662 7.10449C10.4995 7.10449 7.28387 10.3201 7.28387 14.2868C7.28387 18.2535 10.4995 21.4691 14.4662 21.4691Z",
    fill: "#660F2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.64707 22.5616L2.63196 6.01747L2.9947 5.52979H16.8102C17.314 5.52979 17.7271 5.82401 17.7271 6.18474V22.9112C17.7271 23.274 17.316 23.5662 16.8102 23.5662L3.44007 23.5783L3.03702 23.0835L2.6501 22.5646",
    fill: "#660F2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72083 6.15871C2.73192 6.14561 2.8216 6.02671 2.83066 6.01562H16.1706C16.6854 6.01562 17.1046 6.29675 17.1046 6.6474V22.4489C17.1046 22.7975 16.6854 23.0807 16.1706 23.0807H3.0342L2.64728 22.5618L2.72083 6.15871Z",
    fill: "#660F2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8821 6.01758H0.662007C0.296391 6.01758 0 6.31397 0 6.67958V21.8997C0 22.2653 0.296391 22.5617 0.662007 22.5617H15.8821C16.2477 22.5617 16.5441 22.2653 16.5441 21.8997V6.67958C16.5441 6.31397 16.2477 6.01758 15.8821 6.01758Z",
    fill: "#660F2E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.549 19.2648L10.2417 18.0718H12.5512L12.925 19.2648H10.549Z",
    fill: "#EAAB1B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12316 9.30518H9.81854L12.3446 17.3792H10.0765L9.9455 16.8754H6.90954L6.60725 18.0493C6.51949 18.3888 6.32143 18.6895 6.04421 18.9041C5.76698 19.1188 5.42629 19.2353 5.07567 19.2353H4.01666L7.12316 9.30518ZM7.367 15.1222H9.483L9.25528 14.2073C8.98121 13.2178 8.70714 12.0449 8.44919 11.0101H8.38772C8.14488 12.06 7.88391 13.2178 7.61185 14.2073L7.367 15.1222Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPortal);
export default __webpack_public_path__ + "static/media/AdminPortal.9ebdd958c354e2896b6a1681e91403e3.svg";
export { ForwardRef as ReactComponent };